const barThumb = {
    '& .thumb': {
        backgroundColor: '#fff',
        boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
        '&.default .MuiSvgIcon-root': {
            width: '12px',
        },
        '&.starred .MuiSvgIcon-root': {
            width: '13px',
        },
        pointerEvents: 'painted',
    },
    '& .thumb:hover': {
        boxShadow: 'none !important',
        '& .tooltip': {
            opacity: 1,
        },
    },
};
const progressBar = {
    pointerEvents: 'none',
    color: '#0000',
    padding: '0 !important',
    '& .MuiSlider-rail': {
        backgroundColor: '#eee',
        borderRadius: '20px',
        height: '8px',
        opacity: '1',
    },
    '& .MuiSlider-track': {
        border: 'none',
        background: (theme) => 'linear-gradient(90deg, ' +
            theme.palette.primary.light +
            ' 0%, ' +
            theme.palette.primary.dark +
            ' 100%)',
        height: '8px',
    },
    ...barThumb,
};
const progressBarValues = {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '3px',
};
export default {
    progressBar,
    progressBarValues,
};
